import styled from 'styled-components';
import { headline1, headline2, headline3, headline4 } from '../../tokens';
import { applyHyphens, applySpacing } from '../../mixins';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Typography/Headline');
export var Headline1 = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-13i65ks-0"
})(["", " ", " ", ""], applyHyphens, applySpacing, headline1);
export var Headline2 = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-13i65ks-1"
})(["", " ", " ", ""], applyHyphens, applySpacing, headline2);
export var Headline3 = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-13i65ks-2"
})(["", " ", " ", ""], applyHyphens, applySpacing, headline3);
export var Headline4 = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-13i65ks-3"
})(["", " ", " ", ""], applyHyphens, applySpacing, headline4);
export var H1 = /*#__PURE__*/styled.h1.withConfig({
  componentId: "plasma__sc-13i65ks-4"
})(["margin:0;", " ", " ", ""], applyHyphens, applySpacing, headline1);
export var H2 = /*#__PURE__*/styled.h2.withConfig({
  componentId: "plasma__sc-13i65ks-5"
})(["margin:0;", " ", " ", ""], applyHyphens, applySpacing, headline2);
export var H3 = /*#__PURE__*/styled.h3.withConfig({
  componentId: "plasma__sc-13i65ks-6"
})(["margin:0;", " ", " ", ""], applyHyphens, applySpacing, headline3);
export var H4 = /*#__PURE__*/styled.h4.withConfig({
  componentId: "plasma__sc-13i65ks-7"
})(["margin:0;", " ", " ", ""], applyHyphens, applySpacing, headline4);